module.exports = __webpack_public_path__ + "img/05.12730708.png";